/* The strings tiger.js's Arabic dictionary misses.
 *
 * tiger.js carries `var AR = {...}`, 51 English->Arabic pairs, and swaps them
 * on the language button. Its walker only considers *leaf* elements —
 * `if (!el.children.length)` — and matches the element's whole trimmed
 * textContent. That leaves three kinds of gap:
 *
 *   1. Strings simply absent from the map: the footer's policy and catalogue
 *      links, the skip link, the social names, the product page's labels.
 *   2. "Ship to:", which IS in the map and never fires, because its <span>
 *      wraps a <strong> holding the country — one child element, so the leaf
 *      test rejects it and the label stays English beside an Arabic country.
 *   3. Labels carrying a value, like "Size 40". No fixed key can match those,
 *      so they need a pattern rather than a dictionary entry.
 *
 * So this walks text *nodes* rather than elements, which reaches into mixed
 * content the element walker cannot, and touches nothing but its own keys.
 * The two maps are kept disjoint on purpose: a string belongs to one mechanism
 * or the other, never both. Anything a merchant should be able to edit belongs
 * in a section schema `_ar` field instead of either map.
 *
 * Deliberately NOT translated here: product names, colour names, materials, the
 * product description, the SKU, and the delivery panel's prose. Those are
 * Shopify data, not theme chrome, and reach Arabic only through a published
 * locale. Product names are a standing instruction rather than a limitation:
 * they stay in English in both languages. A key here that matches a product
 * title would break that, so do not add one. The
 * delivery sentence in particular wraps <a> tags around "shipping" and
 * "returns" — swapping those fragments alone would leave a half-Arabic
 * sentence, which is worse than an English one.
 *
 * Load order matters. tiger.js applies the stored language synchronously at the
 * end of the body, so by the time this file runs, documentElement already
 * carries the right data-lang and we only have to agree with it.
 */
(function () {
  'use strict';

  var EXTRA = {
    /* footer and global chrome */
    'All products': 'كل المنتجات',
    'Privacy policy': 'سياسة الخصوصية',
    'Kids': 'أطفال',
    'Go to main content': 'انتقل إلى المحتوى الرئيسي',
    'Ship to:': 'الشحن إلى:',
    'Facebook': 'فيسبوك',
    'Instagram': 'إنستغرام',
    'YouTube': 'يوتيوب',

    /* product page chrome */
    'Back': 'رجوع',
    'Color': 'اللون',
    'Colour': 'اللون',
    'Add to cart': 'أضف إلى السلة',
    'More payment options': 'خيارات دفع أخرى',
    'Details': 'التفاصيل',
    'Material': 'الخامة',
    'Made for': 'مخصص لـ',
    'Reference': 'المرجع',
    'Delivery and returns': 'الشحن والإرجاع',
    /* 'Care' is already a key in tiger.js's map and still never fires here,
       the same way 'Ship to:' does not: this panel head is a <button> with a
       span and an icon inside, so the leaf test rejects it. Same gap, same
       fix — not a second translation of a string already covered. */
    'Care': 'العناية'
  };

  /* Labels that carry a value. Kept to exact, anchored shapes so a pattern can
     never reach a product title or a price it was not meant to touch. */
  var PATTERNS = [
    { re: /^Size (\d+)$/, ar: function (m) { return 'المقاس ' + m[1]; } }
  ];

  function translate(en) {
    if (EXTRA.hasOwnProperty(en)) return EXTRA[en];
    for (var i = 0; i < PATTERNS.length; i++) {
      var m = en.match(PATTERNS[i].re);
      if (m) return PATTERNS[i].ar(m);
    }
    return null;
  }

  var swapped = [];      // {node, en, el, taggedLang}
  var isArabic = false;  // what this file last applied, not what the page says

  function toArabic() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue || '';
      var en = raw.trim();
      if (!en) continue;

      var ar = translate(en);
      if (ar === null) continue;

      var el = node.parentElement;
      if (!el || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;

      var tagged = false;
      if (!el.hasAttribute('lang')) { el.setAttribute('lang', 'ar'); tagged = true; }

      swapped.push({ node: node, en: raw, el: el, taggedLang: tagged });
      // replace the phrase, keep whatever spacing sat around it
      node.nodeValue = raw.replace(en, ar);
    }
  }

  function toEnglish() {
    for (var i = 0; i < swapped.length; i++) {
      var s = swapped[i];
      s.node.nodeValue = s.en;
      if (s.taggedLang) s.el.removeAttribute('lang');
    }
    swapped.length = 0;
  }

  function sync() {
    var wantArabic = document.documentElement.getAttribute('data-lang') === 'ar';
    if (wantArabic === isArabic) return;   // never apply twice, never revert twice
    if (wantArabic) toArabic(); else toEnglish();
    isArabic = wantArabic;
  }

  sync();   // the language may already be Arabic, restored from localStorage

  var btn = document.querySelector('.lang-toggle');
  if (btn) {
    // after tiger.js's own handler has moved data-lang
    btn.addEventListener('click', function () { window.setTimeout(sync, 0); });
  }
})();
